import React from 'react';

import {
  ActionLink,
  CalendarAndClockIcon,
  Card,
  Container,
  Description,
  Name,
  TitleIconContainer,
  TitleSection
} from './AppointmentTypeCard.styled';
import { Button } from 'components/v2/Buttons/Button/Button';
import { useFeatureFlags } from 'hooks/useFeatureFlags/useFeatureFlags';
import { AppointmentType } from 'kb-shared/types';
import { NEW_PATIENT_CONSULT_NAME, networkClinicCopy } from 'screens/Book/networkClinicBookingCopy';
import { useBreakpoints } from 'utilities/useBreakpoints';

interface Props {
  appointmentType: AppointmentType;
  onClick?: () => void;
  href?: string;
  buttonLabel?: string;
  footerContent?: React.ReactNode;
}

export const AppointmentTypeCard = ({
  appointmentType,
  onClick,
  href,
  buttonLabel = 'Schedule Appointment',
  footerContent
}: Props) => {
  const { isDesktop } = useBreakpoints();
  const { ppNetworkClinicBooking } = useFeatureFlags();
  const displayName =
    ppNetworkClinicBooking && appointmentType.name === NEW_PATIENT_CONSULT_NAME
      ? networkClinicCopy.virtualNpvName
      : appointmentType.name;

  return (
    <Container>
      <Card>
        <TitleSection>
          <TitleIconContainer>
            <CalendarAndClockIcon />
          </TitleIconContainer>
          <Name>{displayName}</Name>
        </TitleSection>
        {appointmentType.description && (
          <Description dangerouslySetInnerHTML={{ __html: appointmentType.description }} />
        )}
        {footerContent ||
          (href && <ActionLink href={href}>{buttonLabel}</ActionLink>) ||
          (onClick && (
            <Button
              label={buttonLabel}
              size={isDesktop ? 'md' : 'lg'}
              category="primary"
              onClick={onClick}
              fullWidth
            />
          ))}
      </Card>
    </Container>
  );
};
